export { default as component } from "../../../../src/routes/[prefix]/(feature)/order/[id]/+page.svelte";